(() => {
  /**
   * Gets the currently active/visible navigation element.
   * Supports dual-nav rendering where both BAU and refreshed navs are in DOM.
   */
  const getActiveNavEl = () => {
    // Check for refreshed nav (only if it's active/visible)
    const refreshNav = document.querySelector('.o-navRefresh.is-active');
    if (refreshNav) {
      return refreshNav.querySelector('.Header--refresh') || refreshNav;
    }

    // Check for BAU nav (only if not hidden)
    const bauNav = document.querySelector('.o-bauNav:not(.is-hidden)');
    if (bauNav) {
      return bauNav.querySelector('header') || bauNav;
    }

    // Fallback: legacy single-nav rendering (no wrapper classes)
    // Check refreshed nav without wrapper
    const legacyRefresh = document.querySelector('.o-navRefresh:not(.is-active) .Header--refresh');
    if (legacyRefresh && !legacyRefresh.closest('.o-bauNav')) {
      // Only use if there's no dual-nav setup (backwards compat)
      const hasWrapper = document.querySelector('.o-bauNav') || document.querySelector('.o-navRefresh.is-active');
      if (!hasWrapper) return legacyRefresh;
    }

    // Final fallback: any visible header
    return document.querySelector('header');
  };

  const topbar = document.querySelector('.topbarcontainer');
  if (!topbar) return;

  let nav = getActiveNavEl();
  let scheduled = false;
  let lastPx = '';

  function computeNavOffsetPx() {
    if (!nav) return '0px';
    const cs = getComputedStyle(nav);
    const mb = parseFloat(cs.marginBottom) || 0;
    const h = nav.offsetHeight || 0;
    const px = Math.max(0, h - mb);
    return `${px}px`;
  }

  function apply() {
    scheduled = false;
    const px = computeNavOffsetPx();
    if (px !== lastPx) {
      topbar.style.marginTop = px;
      lastPx = px;
    }
  }

  const schedule = () => {
    if (!scheduled) {
      scheduled = true;
      requestAnimationFrame(apply);
    }
  };

  // ResizeObserver on the nav
  const ro = new ResizeObserver(schedule);

  function attachObserver() {
    if (nav) ro.observe(nav);
  }

  function detachObserver() {
    try { if (nav) ro.unobserve(nav); } catch (e) {}
  }

  function rebindNav() {
    const current = getActiveNavEl();
    if (current !== nav) {
      detachObserver();
      nav = current;
      attachObserver();
      schedule();
    }
  }

  // Initial setup
  attachObserver();
  schedule();

  // Listen for nav refresh switch event (from dual-nav toggle)
  document.addEventListener('navRefreshActivated', () => {
    rebindNav();
  });

  // MutationObserver for class changes and DOM updates
  const mo = new MutationObserver(() => {
    rebindNav();
  });

  mo.observe(document.documentElement, {
    subtree: true,
    childList: true,
    attributes: true,
    attributeFilter: ['class']
  });

  // Window resize and load
  window.addEventListener('resize', schedule, { passive: true });
  window.addEventListener('load', schedule);
})();
